var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYoutubeWhite = function SvgYoutubeWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12.372,
    viewBox: "0 0 18 12.372",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube-white-icon",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_7",
    "data-name": "Exclusion 7",
    d: "M-3862,570.909c-1.094,0-4.769-.007-6.142-.1-1.07-.073-1.6-.242-2.1-1.1-.52-.886-.762-2.468-.762-4.979v-.01c0-2.482.242-4.067.762-4.988.5-.893,1.053-1.024,2.1-1.094,1.128-.075,4.012-.1,6.14-.1s5.011.027,6.136.1c1.081.06,1.611.225,2.1,1.089.53.9.766,2.435.766,4.99v.009c0,2.551-.236,4.088-.764,4.983-.492.871-1.021,1.038-2.1,1.1C-3857.008,570.875-3859.816,570.909-3862,570.909Zm-2.253-9.559v6.75l5.626-3.376-5.626-3.374Z",
    transform: "translate(3871 -555.537)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoutubeWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/youtube-white.e3676ba8.svg";
export { ForwardRef as ReactComponent };